import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../../utils/constants';

const tabs = [
  {
    id: 'leaderboard',
    label: 'Leaderboard',
    path: ROUTES.FRIDAVE_HOME,
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
  },
  {
    id: 'scoring',
    label: 'Scoring',
    path: ROUTES.FRIDAVE_SCORING,
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
    ),
  },
  {
    id: 'stats',
    label: 'Stats',
    path: ROUTES.FRIDAVE_STATS,
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    ),
  },
];

export default function FriDaveBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const isScoringView = location.pathname.startsWith('/fridave/rounds/') && location.state?.activeTab === 'enter-scores';

  const isActive = (tab) => {
    if (tab.id === 'scoring') return location.pathname === ROUTES.FRIDAVE_SCORING || isScoringView;
    if (tab.id === 'leaderboard') return location.pathname === ROUTES.FRIDAVE_HOME || (location.pathname.startsWith('/fridave/rounds/') && !isScoringView);
    if (tab.id === 'stats') return location.pathname.startsWith(ROUTES.FRIDAVE_STATS);
    return false;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-top z-50">
      <div className="flex justify-around items-center">
        {tabs.map((tab) => {
          const active = isActive(tab);
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center justify-center py-2 px-4 min-h-[60px] flex-1 transition-colors ${
                active ? 'text-fd-primary' : 'text-gray-400 hover:text-gray-600'
              }`}
            >
              <div>{tab.icon}</div>
              <span className="text-xs font-semibold mt-1">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
